/* eslint react/no-unescaped-entities: 0 */
/* eslint react/display-name: 0 */
import React, { Component } from "react";
import ImportCompressorsContent from "./ImportCompressorsContent";

export default class extends Component {
  static propTypes = ImportCompressorsContent.propTypes;

  /**
   * {@inheritdoc}
   */
  render() {
    return (
      <div>
        <p>
          Pour réaliser l'import de vos compresseurs, les données doivent être
          enregistrées au format ODS ou TSV, et respecter la structure suivante:
        </p>

        <ul>
          <li>N° client</li>
          <li>N° site</li>
          <li>N° installation</li>
          <li>Repère</li>
          <li>Identifiant num <i>(optionnel)</i></li>
          <li>N° série <i>(optionnel)</i></li>
          <li>Type</li>
          <li>Genre</li>
          <li>Marque <i>(optionnel)</i></li>
        </ul>

        <p>{this.props.downloadSample}</p>

        <p>
          Après l'intégration, une synthèse vous informera sur le nombre
          d'entités créées ou mises à jour, et mettra à disposition un fichier
          d'anomalies contenant les lignes non intégrées, et le(s) motif(s) du
          rejet.
        </p>

        <p>Les motifs d'anomalie possibles sont:</p>

        <ul>
          <li>Absence de données obligatoires</li>
          <li>Type inexistant</li>
          <li>Genre inexistant</li>
          <li>Marque inexistante</li>
        </ul>
      </div>
    );
  }
}
